import "core-js/modules/es.array.map.js";
import { Core } from "@faire/design-tokens";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import isEmpty from "lodash/isEmpty";
import React from "react";
import styled from "styled-components";
import { useListOfSelectedNodes } from "../hooks/useListOfSelectedNodes";
export var SelectedIssuesBulletedListCard = function SelectedIssuesBulletedListCard() {
  var _selectedNodes$, _selectedNodes$0$side;
  var _useListOfSelectedNod = useListOfSelectedNodes(),
    selectedNodes = _useListOfSelectedNod.selectedNodes;
  return /*#__PURE__*/React.createElement(React.Fragment, null, (_selectedNodes$ = selectedNodes[0]) !== null && _selectedNodes$ !== void 0 && _selectedNodes$.label ? ( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraphSansMedium"
  }, (_selectedNodes$0$side = selectedNodes[0].sidebarTitle) !== null && _selectedNodes$0$side !== void 0 ? _selectedNodes$0$side : selectedNodes[0].label), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }))) : null, !isEmpty(selectedNodes) ? selectedNodes.map(function (selectedNode) {
    var _selectedNodes$2;
    if (selectedNode.id === ((_selectedNodes$2 = selectedNodes[0]) === null || _selectedNodes$2 === void 0 ? void 0 : _selectedNodes$2.id)) {
      return;
    }
    return /*#__PURE__*/React.createElement(LineItem, {
      key: selectedNode.id
    }, selectedNode.label);
  }) : null);
};
var LineItem = styled(Typography).withConfig({
  displayName: "SelectedIssuesBulletedListCard__LineItem"
})(["&::before{content:\"\";width:6px;height:6px;border-radius:50%;margin-right:8px;margin-left:8px;background-color:", ";vertical-align:middle;display:inline-block;}"], Core.surface["default"]);